import React, { useState } from 'react';
import './FeedbackReportModal.css';
import { Link } from 'react-router-dom';
import { isEmpty } from 'lodash';
import { useSelector } from 'react-redux';
import { isUserLoggedIn } from 'redux/reducers/loggedInUser';

let data = window.navigator.userAgent.toLowerCase();

const isCheck = /mobile|android|iphone|ipod|blackberry|iemobile|opera mini/i.test(
  data
);

const FeedbackReportModal = ({
	onPopupToggle,
	handleScreenshot,
	onStartCapture,
	screenCapture,
	setIsPopupOpen,
	isPopupOpen,
	setIssueTitle,
	issueTitle,
	handleClearScreenshot,
	setShowRecorder,
	showRecorder,
	setIssueDescription,
	issueDescription,
	mediaBlobUrl,
	status,
	resetMediaBlobUrl,
	setSuccessJiraMessage,
	successJiraMessage,
	projectKey,
	createJiraIssue,
	handleAttachmentChange,
	attachmentFile,
	setAttachmentFile,
	email,
	setEmail,
	handleReset,
	onClosePopup,
	popupType,
	setPopupType,
	handleRemoveAttachmentFile,
	inputFileRef,
	setSubmitLoader,
	submitLoader,
}) => {
	const isLoggedIn = useSelector(isUserLoggedIn);
	return (
		<div className="popup-container">
			<div
				className={
					popupType === 0 || popupType === 4
						? 'ReportBugContainer'
						: 'ReportBugContainer BugFormContainer'
				}
			>
				{/* {popupType !== 0 && (
					<div
						class="ReportBug_BackBTN"
						title="Back"
						href="#"
						style={{ cursor: 'pointer' }}
						onClick={() => {
							setPopupType(0);
						}}
					>
						<svg xmlns="http://www.w3.org/2000/svg" width="12px" viewBox="0 0 320 512">
							<path d="M15 239c-9.4 9.4-9.4 24.6 0 33.9L207 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L65.9 256 241 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L15 239z"></path>
						</svg>
					</div>
				)} */}

				<span
					className="ReportBug_Close"
					title="Close"
					style={{ cursor: 'pointer' }}
					onClick={onClosePopup}
				>
					<svg xmlns="http://www.w3.org/2000/svg" width="16px" viewBox="0 0 384 512">
						<path d="M345 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-119 119L73 103c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l119 119L39 375c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l119-119L311 409c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-119-119L345 137z"></path>
					</svg>
				</span>
				{popupType === 0 && (
					<>
						<div className="SW_Logo_RB">
							<img
								src="https://dev-erp.sworks.co.in/static/media/SW-newlogo.1b34b5c6.svg"
								alt="Smartworks"
							/>
						</div>

						<div className="bugOptions_box">
							<div
								onClick={() => setPopupType(1)}
								style={{ cursor: 'pointer' }}
								className="bugOptions d-flex align-items-center cursor-pointer"
							>
								<div className="BugIcon">
									<svg width="20" viewBox="0 0 30 24" xmlns="http://www.w3.org/2000/svg">
										<path d="M5.25 0.875H8.5V2.5H11.75V5.75H18.25V2.5H21.5V0.875H24.75V4.125H21.5V5.75V7.375H24.75V10.625H26.375V5.75H29.625V13.875H26.375V18.75H23.125V23.625H19.875H16.625V20.375H19.875V18.75H10.125V20.375H13.375V23.625H10.125H6.875V18.75H3.625V13.875H0.375V5.75H3.625V10.625H5.25V7.375H8.5V5.75V4.125H5.25V0.875ZM8.5 15.5H11.75V10.625H8.5V15.5ZM18.25 15.5H21.5V10.625H18.25V15.5Z"></path>
									</svg>
								</div>
								<div className="BugDetail">
									<div className="BugTitle">Report a bug</div>
									<div className="BugDescription">Let us know what's broken</div>
								</div>
							</div>

							<div
								onClick={() => setPopupType(2)}
								className="bugOptions d-flex align-items-center"
								style={{ cursor: 'pointer' }}
							>
								<div className="BugIcon">
									<svg xmlns="http://www.w3.org/2000/svg" width="20" viewBox="0 0 512 512">
										<path d="M327.5 85.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 128l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 128l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 64 426.8 7.5C425.1 3 420.8 0 416 0s-9.1 3-10.8 7.5L384 64 327.5 85.2zM205.1 73.3c-2.6-5.7-8.3-9.3-14.5-9.3s-11.9 3.6-14.5 9.3L123.3 187.3 9.3 240C3.6 242.6 0 248.3 0 254.6s3.6 11.9 9.3 14.5l114.1 52.7L176 435.8c2.6 5.7 8.3 9.3 14.5 9.3s11.9-3.6 14.5-9.3l52.7-114.1 114.1-52.7c5.7-2.6 9.3-8.3 9.3-14.5s-3.6-11.9-9.3-14.5L257.8 187.4 205.1 73.3zM384 384l-56.5 21.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 448l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 448l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 384l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L384 384z"></path>
									</svg>
								</div>
								<div className="BugDetail">
									<div className="BugTitle">Feature request</div>
									<div className="BugDescription">Tell us how we can improve.</div>
								</div>
							</div>

							<div
								onClick={() => setPopupType(3)}
								style={{ cursor: 'pointer' }}
								className="bugOptions d-flex align-items-center"
							>
								<div className="BugIcon">
									<svg xmlns="http://www.w3.org/2000/svg" width="18" viewBox="0 0 384 512">
										<path d="M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM112 256H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"></path>
									</svg>
								</div>
								<div className="BugDetail">
									<div className="BugTitle">General feedback</div>
									<div className="BugDescription">Give general feedback of this page</div>
								</div>
							</div>
							<Link
								to="/app/bug-tracker"
								style={{ cursor: 'pointer' }}
								onClick={onClosePopup}
								className="bugOptions d-flex align-items-center"
							>
								<div className="BugIcon">
								<svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
									<circle cx="30" cy="30" r="29.5" stroke="#CCCCCC" stroke-opacity="0.8"/>
									<mask id="mask0_357_887" maskUnits="userSpaceOnUse" x="12" y="12" width="36" height="36">
									<rect x="12" y="12" width="36" height="36" fill="#D9D9D9"/>
									</mask>
									<g mask="url(#mask0_357_887)">
									<path d="M17.1 39L15 36.9L26.1 25.725L32.1 31.725L39.9 24H36V21H45V30H42V26.1L32.1 36L26.1 30L17.1 39Z" fill="#D8D8D8"/>
									</g>
									</svg>

								</div>
								<div className="BugDetail">
									<div className="BugTitle">My Issues</div>
									<div className="BugDescription">Check the status of the raised concerns</div>
								</div>
							</Link>
						</div>
						

						{/* <img
							className="popup-header-img"
							src="https://erp.sworks.co.in/static/media/SW-newlogo.1b34b5c6.svg"
						/>
						<div className="popup-header-bug">
							<div className="popup-header-bug-container" onClick={() => setPopupType(1)}>
								<svg
									className="popup-header-bug-container-img"
									width="30"
									height="24"
									viewBox="0 0 30 24"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path d="M5.25 0.875H8.5V2.5H11.75V5.75H18.25V2.5H21.5V0.875H24.75V4.125H21.5V5.75V7.375H24.75V10.625H26.375V5.75H29.625V13.875H26.375V18.75H23.125V23.625H19.875H16.625V20.375H19.875V18.75H10.125V20.375H13.375V23.625H10.125H6.875V18.75H3.625V13.875H0.375V5.75H3.625V10.625H5.25V7.375H8.5V5.75V4.125H5.25V0.875ZM8.5 15.5H11.75V10.625H8.5V15.5ZM18.25 15.5H21.5V10.625H18.25V15.5Z"></path>
								</svg>
								<div className="popup-header-bug-container-right">
									<p className="popup-header-bug-container-right-heading">Report a bug</p>
									<p className="popup-header-bug-container-right-text">Let us know what's broken</p>
								</div>
							</div>
						</div>
						<div className="popup-header-feature">
							<div className="popup-header-feature-container" onClick={() => setPopupType(2)}>
								<svg
									className="popup-header-feature-container-img"
									xmlns="http://www.w3.org/2000/svg"
									viewBox="0 0 512 512"
								>
									<path d="M327.5 85.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 128l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 128l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 64 426.8 7.5C425.1 3 420.8 0 416 0s-9.1 3-10.8 7.5L384 64 327.5 85.2zM205.1 73.3c-2.6-5.7-8.3-9.3-14.5-9.3s-11.9 3.6-14.5 9.3L123.3 187.3 9.3 240C3.6 242.6 0 248.3 0 254.6s3.6 11.9 9.3 14.5l114.1 52.7L176 435.8c2.6 5.7 8.3 9.3 14.5 9.3s11.9-3.6 14.5-9.3l52.7-114.1 114.1-52.7c5.7-2.6 9.3-8.3 9.3-14.5s-3.6-11.9-9.3-14.5L257.8 187.4 205.1 73.3zM384 384l-56.5 21.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 448l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 448l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 384l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L384 384z"></path>
								</svg>
								<div className="popup-header-feature-container-right">
									<p className="popup-header-feature-container-right-heading">Feature Request</p>
									<p className="popup-header-feature-container-right-text">
										Tell us how we can improve
									</p>
								</div>
							</div>
						</div>
						<div className="popup-header-feedback">
							<div className="popup-header-feedback-container" onClick={() => setPopupType(3)}>
								<svg
									className="popup-header-feedback-container-img"
									xmlns="http://www.w3.org/2000/svg"
									viewBox="0 0 384 512"
								>
									<path d="M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM112 256H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"></path>
								</svg>
								<div className="popup-header-feedback-container-right">
									<p className="popup-header-feedback-container-right-heading">General feedback</p>
									<p className="popup-header-feedback-container-right-text">
										Give general feedback of this page
									</p>
								</div>
							</div>
						</div> */}
					</>
				)}
				{popupType === 1 && (
					<>
						<div className="BugFormTitle">Report a bug</div>
						<div class="Bug_Form">
							<p class="text-center">Tell us what's broken</p>
							<div className="popup-content">
								<form onSubmit={createJiraIssue}>
									<div className="mb-2">
										<input
											className="form-control"
											placeholder="Your Email address"
											type="email"
											required
											readOnly={isLoggedIn}
											value={email}
											onChange={(e) => setEmail(e.target.value)}
										/>
									</div>
									<div className="mb-2">
										<input
											className="form-control"
											value={issueTitle}
											placeholder="Add a title"
											required
											onChange={(e) => setIssueTitle(e.target.value)}
										/>
									</div>
									<div className="mb-2">
										<textarea
											rows="3"
											className="form-control"
											placeholder="Describe the bug in detail"
											required
											value={issueDescription}
											onChange={(e) => setIssueDescription(e.target.value)}
										/>
									</div>

									{(screenCapture && attachmentFile) || (mediaBlobUrl && attachmentFile) ? (
										<></>
									) : (
										<div className="BugAttachment_Btns btn-group w-100">
											<div
												className="btn btn-outline-secondary BugBTN-Tooltip"
												// role="button"
												// type="button"
												// disabled={mediaBlobUrl || screenCapture ? true : false}
												disabled={isCheck ? true: false}
												onClick={() => {
													onStartCapture();
													setIsPopupOpen(!isPopupOpen)
													setShowRecorder(false);
												}}
											>
												{screenCapture && (
													<svg
														class="attachement_checkmark"
														xmlns="http://www.w3.org/2000/svg"
														width="16"
														height="16"
														viewBox="0 0 30 30"
													>
														<path
															id="check_circle"
															d="M12.9,21.9,23.475,11.325l-2.1-2.1L12.9,17.7,8.625,13.425l-2.1,2.1ZM15,30a14.606,14.606,0,0,1-5.85-1.181A14.976,14.976,0,0,1,1.181,20.85,14.606,14.606,0,0,1,0,15,14.606,14.606,0,0,1,1.181,9.15,14.977,14.977,0,0,1,9.15,1.181,14.606,14.606,0,0,1,15,0a14.606,14.606,0,0,1,5.85,1.181A14.977,14.977,0,0,1,28.819,9.15,14.606,14.606,0,0,1,30,15a14.606,14.606,0,0,1-1.181,5.85,14.977,14.977,0,0,1-7.969,7.969A14.606,14.606,0,0,1,15,30Z"
															transform="translate(0 0)"
															fill="#00c878"
														/>
													</svg>
												)}
												<span class="BugBTN-TooltipText">Screenshot</span>
												<svg
													className="screenshot_button_container-img"
													xmlns="http://www.w3.org/2000/svg"
													viewBox="0 0 448 512"
												>
													<path d="M400 354.2V157.8C427.5 150.6 448 125.8 448 96c0-35.38-28.62-64-64-64c-29.75 0-54.63 20.5-61.75 48H125.8C118.6 52.5 93.75 32 64 32C28.62 32 0 60.62 0 96c0 29.75 20.5 54.62 48 61.75v196.5C20.5 361.4 0 386.2 0 416c0 35.38 28.62 64 64 64c29.75 0 54.62-20.5 61.75-48h196.5c7.125 27.5 32 48 61.75 48c35.38 0 64-28.62 64-64C448 386.2 427.5 361.4 400 354.2zM322.2 400H125.8C120 377.6 102.4 360.1 80 354.2V157.8C102.4 152 119.9 134.4 125.8 112h196.5C328.1 134.4 345.6 151.9 368 157.8v196.5C345.6 360.1 328.1 377.6 322.2 400zM384 64c17.62 0 32 14.38 32 32s-14.38 32-32 32s-32-14.38-32-32S366.4 64 384 64zM32 96c0-17.62 14.38-32 32-32s32 14.38 32 32S81.62 128 64 128S32 113.6 32 96zM64 448c-17.62 0-32-14.38-32-32s14.38-32 32-32s32 14.38 32 32S81.62 448 64 448zM384 448c-17.62 0-32-14.38-32-32s14.38-32 32-32s32 14.38 32 32S401.6 448 384 448z"></path>
												</svg>
											</div>
											<button
												className="btn btn-outline-secondary BugBTN-Tooltip no-cursor"
												disabled={screenCapture || mediaBlobUrl || isCheck ? true : false}
												onClick={() => {
													setShowRecorder(true);
													setIsPopupOpen(!isPopupOpen);
												}}
											>
												{mediaBlobUrl && (
													<svg
														class="attachement_checkmark"
														xmlns="http://www.w3.org/2000/svg"
														width="16"
														height="16"
														viewBox="0 0 30 30"
													>
														<path
															id="check_circle"
															d="M12.9,21.9,23.475,11.325l-2.1-2.1L12.9,17.7,8.625,13.425l-2.1,2.1ZM15,30a14.606,14.606,0,0,1-5.85-1.181A14.976,14.976,0,0,1,1.181,20.85,14.606,14.606,0,0,1,0,15,14.606,14.606,0,0,1,1.181,9.15,14.977,14.977,0,0,1,9.15,1.181,14.606,14.606,0,0,1,15,0a14.606,14.606,0,0,1,5.85,1.181A14.977,14.977,0,0,1,28.819,9.15,14.606,14.606,0,0,1,30,15a14.606,14.606,0,0,1-1.181,5.85,14.977,14.977,0,0,1-7.969,7.969A14.606,14.606,0,0,1,15,30Z"
															transform="translate(0 0)"
															fill="#00c878"
														/>
													</svg>
												)}
												<span class="BugBTN-TooltipText">Record Screen</span>
												<svg
													className="recording_button_container-img"
													xmlns="http://www.w3.org/2000/svg"
													viewBox="0 0 576 512"
												>
													<path d="M558.8 99.64c-10.59-5.484-23.37-4.76-33.15 2.099l-102.8 72.04c-7.25 5.062-9 15.05-3.938 22.28C423.1 203.3 433.9 205 441.2 200L544 128v255.9L441.2 312c-7.266-5.047-17.22-3.312-22.28 3.938c-5.062 7.234-3.312 17.22 3.938 22.28l102.8 71.98c5.5 3.844 11.94 5.786 18.38 5.786c5.047 0 10.12-1.203 14.78-3.625C569.4 406.8 576 395.1 576 383.1V128C576 116 569.4 105.2 558.8 99.64zM320 64H64C28.65 64 0 92.65 0 128v256c0 35.35 28.65 64 64 64h256c35.35 0 64-28.65 64-64V128C384 92.65 355.3 64 320 64zM352 384c0 17.64-14.36 32-32 32H64c-17.64 0-32-14.36-32-32V128c0-17.64 14.36-32 32-32h256c17.64 0 32 14.36 32 32V384z"></path>
												</svg>
											</button>
											<button
												className="btn btn-outline-secondary BugBTN-Tooltip attachment_button_container"
												disabled={attachmentFile ? true : false}
												type="button"
											>
												<input
													id="file-input"
													name="file-input"
													type="file"
													accept="image/*"
													ref={inputFileRef}
													onChange={handleAttachmentChange}
												/>
												<svg
													className="attachment_button_container-img"
													xmlns="http://www.w3.org/2000/svg"
													viewBox="0 0 512 512"
												>
													<path d="M149.106 512c-33.076 0-66.153-12.59-91.333-37.771-50.364-50.361-50.364-132.305-.002-182.665L319.842 29.498c39.331-39.331 103.328-39.331 142.66 0 39.331 39.332 39.331 103.327 0 142.657l-222.63 222.626c-28.297 28.301-74.347 28.303-102.65 0-28.3-28.301-28.3-74.349 0-102.649l170.301-170.298c4.686-4.686 12.284-4.686 16.97 0l5.661 5.661c4.686 4.686 4.686 12.284 0 16.971l-170.3 170.297c-15.821 15.821-15.821 41.563.001 57.385 15.821 15.82 41.564 15.82 57.385 0l222.63-222.626c26.851-26.851 26.851-70.541 0-97.394-26.855-26.851-70.544-26.849-97.395 0L80.404 314.196c-37.882 37.882-37.882 99.519 0 137.401 37.884 37.881 99.523 37.882 137.404.001l217.743-217.739c4.686-4.686 12.284-4.686 16.97 0l5.661 5.661c4.686 4.686 4.686 12.284 0 16.971L240.44 474.229C215.26 499.41 182.183 512 149.106 512z"></path>
												</svg>
												<label for="file-input" style={{ opacity: '0' }}></label>
												{attachmentFile && (
													<svg
														class="attachement_checkmark"
														xmlns="http://www.w3.org/2000/svg"
														width="16"
														height="16"
														viewBox="0 0 30 30"
													>
														<path
															id="check_circle"
															d="M12.9,21.9,23.475,11.325l-2.1-2.1L12.9,17.7,8.625,13.425l-2.1,2.1ZM15,30a14.606,14.606,0,0,1-5.85-1.181A14.976,14.976,0,0,1,1.181,20.85,14.606,14.606,0,0,1,0,15,14.606,14.606,0,0,1,1.181,9.15,14.977,14.977,0,0,1,9.15,1.181,14.606,14.606,0,0,1,15,0a14.606,14.606,0,0,1,5.85,1.181A14.977,14.977,0,0,1,28.819,9.15,14.606,14.606,0,0,1,30,15a14.606,14.606,0,0,1-1.181,5.85,14.977,14.977,0,0,1-7.969,7.969A14.606,14.606,0,0,1,15,30Z"
															transform="translate(0 0)"
															fill="#00c878"
														/>
													</svg>
												)}
												<span class="BugBTN-TooltipText">Attach a file</span>
											</button>
										</div>
									)}
									{attachmentFile && (
										<div className="Attachements_row d-flex align-items-center">
											<div>
												<svg
													className="attachment_button_container-img"
													xmlns="http://www.w3.org/2000/svg"
													viewBox="0 0 512 512"
												>
													<path d="M149.106 512c-33.076 0-66.153-12.59-91.333-37.771-50.364-50.361-50.364-132.305-.002-182.665L319.842 29.498c39.331-39.331 103.328-39.331 142.66 0 39.331 39.332 39.331 103.327 0 142.657l-222.63 222.626c-28.297 28.301-74.347 28.303-102.65 0-28.3-28.301-28.3-74.349 0-102.649l170.301-170.298c4.686-4.686 12.284-4.686 16.97 0l5.661 5.661c4.686 4.686 4.686 12.284 0 16.971l-170.3 170.297c-15.821 15.821-15.821 41.563.001 57.385 15.821 15.82 41.564 15.82 57.385 0l222.63-222.626c26.851-26.851 26.851-70.541 0-97.394-26.855-26.851-70.544-26.849-97.395 0L80.404 314.196c-37.882 37.882-37.882 99.519 0 137.401 37.884 37.881 99.523 37.882 137.404.001l217.743-217.739c4.686-4.686 12.284-4.686 16.97 0l5.661 5.661c4.686 4.686 4.686 12.284 0 16.971L240.44 474.229C215.26 499.41 182.183 512 149.106 512z"></path>
												</svg>

												<span class="Attachement_type"> {`${attachmentFile.name}`}</span>
											</div>
											<div class="ms-auto">
												<span href="#" class="Att_Del_icon" style={{ cursor: 'pointer' }}>
													<svg
														onClick={handleRemoveAttachmentFile}
														xmlns="http://www.w3.org/2000/svg"
														width="24"
														height="24"
														viewBox="0 0 24 24"
													>
														<path
															fill="#000000"
															fill-rule="evenodd"
															d="M13,18 L13,10 L15,10 L15,18 L13,18 Z M17.00005,20 L17.00005,10 L19.00005,10 L19.00005,20 C19.00005,21.1045 18.10455,22 17.00005,22 L7.00005,22 C5.89555,22 5.00005,21.1045 5.00005,20 L5.00005,10 L7.00005,10 L7.00005,20 L17.00005,20 Z M9,18 L9,10 L11,10 L11,18 L9,18 Z M9,6 L15,6 L15,4 L9,4 L9,6 Z M17,6 L20,6 C20.5525,6 21,6.448 21,7 L21,8 L3,8 L3,7 C3,6.448 3.448,6 4,6 L7,6 L7,4 C7,2.8955 7.8955,2 9,2 L15,2 C16.1045,2 17,2.8955 17,4 L17,6 Z"
														></path>
													</svg>
												</span>
											</div>
										</div>
									)}
									{screenCapture && (
										<div className="Attachements_row d-flex align-items-center">
											<div>
												<svg
													xmlns="http://www.w3.org/2000/svg"
													width="16px"
													viewBox="0 0 448 512"
													className="attachment_button_container-img"
												>
													<path d="M400 354.2V157.8C427.5 150.6 448 125.8 448 96c0-35.38-28.62-64-64-64c-29.75 0-54.63 20.5-61.75 48H125.8C118.6 52.5 93.75 32 64 32C28.62 32 0 60.62 0 96c0 29.75 20.5 54.62 48 61.75v196.5C20.5 361.4 0 386.2 0 416c0 35.38 28.62 64 64 64c29.75 0 54.62-20.5 61.75-48h196.5c7.125 27.5 32 48 61.75 48c35.38 0 64-28.62 64-64C448 386.2 427.5 361.4 400 354.2zM322.2 400H125.8C120 377.6 102.4 360.1 80 354.2V157.8C102.4 152 119.9 134.4 125.8 112h196.5C328.1 134.4 345.6 151.9 368 157.8v196.5C345.6 360.1 328.1 377.6 322.2 400zM384 64c17.62 0 32 14.38 32 32s-14.38 32-32 32s-32-14.38-32-32S366.4 64 384 64zM32 96c0-17.62 14.38-32 32-32s32 14.38 32 32S81.62 128 64 128S32 113.6 32 96zM64 448c-17.62 0-32-14.38-32-32s14.38-32 32-32s32 14.38 32 32S81.62 448 64 448zM384 448c-17.62 0-32-14.38-32-32s14.38-32 32-32s32 14.38 32 32S401.6 448 384 448z"></path>
												</svg>
												<span class="Attachement_type">Screenshot</span>
											</div>
											<div class="ms-auto">
												<span href="#" class="Att_Del_icon" style={{ cursor: 'pointer' }}>
													<svg
														onClick={handleClearScreenshot}
														xmlns="http://www.w3.org/2000/svg"
														width="24"
														height="24"
														viewBox="0 0 24 24"
													>
														<path
															fill="#000000"
															fill-rule="evenodd"
															d="M13,18 L13,10 L15,10 L15,18 L13,18 Z M17.00005,20 L17.00005,10 L19.00005,10 L19.00005,20 C19.00005,21.1045 18.10455,22 17.00005,22 L7.00005,22 C5.89555,22 5.00005,21.1045 5.00005,20 L5.00005,10 L7.00005,10 L7.00005,20 L17.00005,20 Z M9,18 L9,10 L11,10 L11,18 L9,18 Z M9,6 L15,6 L15,4 L9,4 L9,6 Z M17,6 L20,6 C20.5525,6 21,6.448 21,7 L21,8 L3,8 L3,7 C3,6.448 3.448,6 4,6 L7,6 L7,4 C7,2.8955 7.8955,2 9,2 L15,2 C16.1045,2 17,2.8955 17,4 L17,6 Z"
														></path>
													</svg>
												</span>
											</div>
										</div>
									)}
									{mediaBlobUrl && (
										<div className="Attachements_row d-flex align-items-center">
											<div>
												<svg
													className="recording_button_container-img"
													xmlns="http://www.w3.org/2000/svg"
													viewBox="0 0 576 512"
												>
													<path d="M558.8 99.64c-10.59-5.484-23.37-4.76-33.15 2.099l-102.8 72.04c-7.25 5.062-9 15.05-3.938 22.28C423.1 203.3 433.9 205 441.2 200L544 128v255.9L441.2 312c-7.266-5.047-17.22-3.312-22.28 3.938c-5.062 7.234-3.312 17.22 3.938 22.28l102.8 71.98c5.5 3.844 11.94 5.786 18.38 5.786c5.047 0 10.12-1.203 14.78-3.625C569.4 406.8 576 395.1 576 383.1V128C576 116 569.4 105.2 558.8 99.64zM320 64H64C28.65 64 0 92.65 0 128v256c0 35.35 28.65 64 64 64h256c35.35 0 64-28.65 64-64V128C384 92.65 355.3 64 320 64zM352 384c0 17.64-14.36 32-32 32H64c-17.64 0-32-14.36-32-32V128c0-17.64 14.36-32 32-32h256c17.64 0 32 14.36 32 32V384z"></path>
												</svg>
												<a href={mediaBlobUrl} target="_blank" className="Attachement_type">
													video.mp4
												</a>
											</div>
											<div class="ms-auto">
												<span href="#" class="Att_Del_icon" style={{ cursor: 'pointer' }}>
													<svg
													onClick={handleReset}
														xmlns="http://www.w3.org/2000/svg"
														width="24"
														height="24"
														viewBox="0 0 24 24"
													>
														<path
															fill="#000000"
															fill-rule="evenodd"
															d="M13,18 L13,10 L15,10 L15,18 L13,18 Z M17.00005,20 L17.00005,10 L19.00005,10 L19.00005,20 C19.00005,21.1045 18.10455,22 17.00005,22 L7.00005,22 C5.89555,22 5.00005,21.1045 5.00005,20 L5.00005,10 L7.00005,10 L7.00005,20 L17.00005,20 Z M9,18 L9,10 L11,10 L11,18 L9,18 Z M9,6 L15,6 L15,4 L9,4 L9,6 Z M17,6 L20,6 C20.5525,6 21,6.448 21,7 L21,8 L3,8 L3,7 C3,6.448 3.448,6 4,6 L7,6 L7,4 C7,2.8955 7.8955,2 9,2 L15,2 C16.1045,2 17,2.8955 17,4 L17,6 Z"
														></path>
													</svg>
												</span>
											</div>
										</div>
									)}
									<div className="create_issue_button_container">
										<button
											disabled={submitLoader}
											className="create_issue_button_container-btn"
											type="submit"
										>
											{submitLoader ? (
												<>
													<svg
														xmlns="http://www.w3.org/2000/svg"
														width={14}
														height={14}
														preserveAspectRatio="xMidYMid"
														style={{
															margin: 'auto',
															background: 'transparent',
															display: 'block',
															shapeRendering: 'auto',
														}}
														viewBox="0 0 100 100"
													>
														<circle
															cx={50}
															cy={50}
															r={35}
															fill="none"
															stroke="#fff"
															strokeDasharray="164.93361431346415 56.97787143782138"
															strokeWidth={10}
														>
															<animateTransform
																attributeName="transform"
																dur="1s"
																keyTimes="0;1"
																repeatCount="indefinite"
																type="rotate"
																values="0 50 50;360 50 50"
															/>
														</circle>
													</svg>
												</>
											) : (
												'Submit'
											)}
										</button>
									</div>
								</form>

								{successJiraMessage && <p className="success_message_jira">Successfully send</p>}
							</div>
						</div>
					</>
				)}
				{popupType === 2 && (
					<>
						<div className="BugFormTitle">Feature Request</div>
						<div class="Bug_Form">
							<p class="text-center">Tell us how we can improve</p>
							<div className="popup-content">
								<form onSubmit={createJiraIssue}>
									<div className="mb-2">
										<input
											className="form-control"
											placeholder="Your Email address"
											type="email"
											required
											readOnly={isLoggedIn}
											value={email}
											onChange={(e) => setEmail(e.target.value)}
										/>
									</div>
									<div className="mb-2">
										<input
											className="form-control"
											value={issueTitle}
											placeholder="Add a title"
											required
											onChange={(e) => setIssueTitle(e.target.value)}
										/>
									</div>
									<div className="mb-2">
										<textarea
											rows="3"
											className="form-control"
											placeholder="Tell us more, including the problem it solves"
											required
											value={issueDescription}
											onChange={(e) => setIssueDescription(e.target.value)}
										/>
									</div>

									{(screenCapture && attachmentFile) || (mediaBlobUrl && attachmentFile) ? (
										<></>
									) : (
										<div className="BugAttachment_Btns btn-group w-100">
											<button
												className="btn btn-outline-secondary BugBTN-Tooltip"
												role="button"
												disabled={mediaBlobUrl || screenCapture || isCheck? true : false}
												onClick={() => {
													onStartCapture();
													setIsPopupOpen(!isPopupOpen);
													setShowRecorder(false);
												}}
											>
												{screenCapture && (
													<svg
														class="attachement_checkmark"
														xmlns="http://www.w3.org/2000/svg"
														width="16"
														height="16"
														viewBox="0 0 30 30"
													>
														<path
															id="check_circle"
															d="M12.9,21.9,23.475,11.325l-2.1-2.1L12.9,17.7,8.625,13.425l-2.1,2.1ZM15,30a14.606,14.606,0,0,1-5.85-1.181A14.976,14.976,0,0,1,1.181,20.85,14.606,14.606,0,0,1,0,15,14.606,14.606,0,0,1,1.181,9.15,14.977,14.977,0,0,1,9.15,1.181,14.606,14.606,0,0,1,15,0a14.606,14.606,0,0,1,5.85,1.181A14.977,14.977,0,0,1,28.819,9.15,14.606,14.606,0,0,1,30,15a14.606,14.606,0,0,1-1.181,5.85,14.977,14.977,0,0,1-7.969,7.969A14.606,14.606,0,0,1,15,30Z"
															transform="translate(0 0)"
															fill="#00c878"
														/>
													</svg>
												)}
												<span class="BugBTN-TooltipText">Screenshot</span>
												<svg
													className="screenshot_button_container-img"
													xmlns="http://www.w3.org/2000/svg"
													viewBox="0 0 448 512"
												>
													<path d="M400 354.2V157.8C427.5 150.6 448 125.8 448 96c0-35.38-28.62-64-64-64c-29.75 0-54.63 20.5-61.75 48H125.8C118.6 52.5 93.75 32 64 32C28.62 32 0 60.62 0 96c0 29.75 20.5 54.62 48 61.75v196.5C20.5 361.4 0 386.2 0 416c0 35.38 28.62 64 64 64c29.75 0 54.62-20.5 61.75-48h196.5c7.125 27.5 32 48 61.75 48c35.38 0 64-28.62 64-64C448 386.2 427.5 361.4 400 354.2zM322.2 400H125.8C120 377.6 102.4 360.1 80 354.2V157.8C102.4 152 119.9 134.4 125.8 112h196.5C328.1 134.4 345.6 151.9 368 157.8v196.5C345.6 360.1 328.1 377.6 322.2 400zM384 64c17.62 0 32 14.38 32 32s-14.38 32-32 32s-32-14.38-32-32S366.4 64 384 64zM32 96c0-17.62 14.38-32 32-32s32 14.38 32 32S81.62 128 64 128S32 113.6 32 96zM64 448c-17.62 0-32-14.38-32-32s14.38-32 32-32s32 14.38 32 32S81.62 448 64 448zM384 448c-17.62 0-32-14.38-32-32s14.38-32 32-32s32 14.38 32 32S401.6 448 384 448z"></path>
												</svg>
											</button>
											<button
												className="btn btn-outline-secondary BugBTN-Tooltip no-cursor"
												disabled={screenCapture || mediaBlobUrl || isCheck ? true : false}
												onClick={() => {
													setShowRecorder(true);
													setIsPopupOpen(!isPopupOpen);
												}}
											>
												{mediaBlobUrl && (
													<svg
														class="attachement_checkmark"
														xmlns="http://www.w3.org/2000/svg"
														width="16"
														height="16"
														viewBox="0 0 30 30"
													>
														<path
															id="check_circle"
															d="M12.9,21.9,23.475,11.325l-2.1-2.1L12.9,17.7,8.625,13.425l-2.1,2.1ZM15,30a14.606,14.606,0,0,1-5.85-1.181A14.976,14.976,0,0,1,1.181,20.85,14.606,14.606,0,0,1,0,15,14.606,14.606,0,0,1,1.181,9.15,14.977,14.977,0,0,1,9.15,1.181,14.606,14.606,0,0,1,15,0a14.606,14.606,0,0,1,5.85,1.181A14.977,14.977,0,0,1,28.819,9.15,14.606,14.606,0,0,1,30,15a14.606,14.606,0,0,1-1.181,5.85,14.977,14.977,0,0,1-7.969,7.969A14.606,14.606,0,0,1,15,30Z"
															transform="translate(0 0)"
															fill="#00c878"
														/>
													</svg>
												)}
												<span class="BugBTN-TooltipText">Record Screen</span>
												<svg
													className="recording_button_container-img"
													xmlns="http://www.w3.org/2000/svg"
													viewBox="0 0 576 512"
												>
													<path d="M558.8 99.64c-10.59-5.484-23.37-4.76-33.15 2.099l-102.8 72.04c-7.25 5.062-9 15.05-3.938 22.28C423.1 203.3 433.9 205 441.2 200L544 128v255.9L441.2 312c-7.266-5.047-17.22-3.312-22.28 3.938c-5.062 7.234-3.312 17.22 3.938 22.28l102.8 71.98c5.5 3.844 11.94 5.786 18.38 5.786c5.047 0 10.12-1.203 14.78-3.625C569.4 406.8 576 395.1 576 383.1V128C576 116 569.4 105.2 558.8 99.64zM320 64H64C28.65 64 0 92.65 0 128v256c0 35.35 28.65 64 64 64h256c35.35 0 64-28.65 64-64V128C384 92.65 355.3 64 320 64zM352 384c0 17.64-14.36 32-32 32H64c-17.64 0-32-14.36-32-32V128c0-17.64 14.36-32 32-32h256c17.64 0 32 14.36 32 32V384z"></path>
												</svg>
											</button>
											<button
												className="btn btn-outline-secondary BugBTN-Tooltip attachment_button_container"
												disabled={attachmentFile ? true : false}
												type="button"
											>
												<input
													id="file-input"
													name="file-input"
													type="file"
													accept="image/*"
													ref={inputFileRef}
													onChange={handleAttachmentChange}
												/>
												<svg
													className="attachment_button_container-img"
													xmlns="http://www.w3.org/2000/svg"
													viewBox="0 0 512 512"
												>
													<path d="M149.106 512c-33.076 0-66.153-12.59-91.333-37.771-50.364-50.361-50.364-132.305-.002-182.665L319.842 29.498c39.331-39.331 103.328-39.331 142.66 0 39.331 39.332 39.331 103.327 0 142.657l-222.63 222.626c-28.297 28.301-74.347 28.303-102.65 0-28.3-28.301-28.3-74.349 0-102.649l170.301-170.298c4.686-4.686 12.284-4.686 16.97 0l5.661 5.661c4.686 4.686 4.686 12.284 0 16.971l-170.3 170.297c-15.821 15.821-15.821 41.563.001 57.385 15.821 15.82 41.564 15.82 57.385 0l222.63-222.626c26.851-26.851 26.851-70.541 0-97.394-26.855-26.851-70.544-26.849-97.395 0L80.404 314.196c-37.882 37.882-37.882 99.519 0 137.401 37.884 37.881 99.523 37.882 137.404.001l217.743-217.739c4.686-4.686 12.284-4.686 16.97 0l5.661 5.661c4.686 4.686 4.686 12.284 0 16.971L240.44 474.229C215.26 499.41 182.183 512 149.106 512z"></path>
												</svg>
												<label for="file-input" style={{ opacity: '0' }}></label>
												{attachmentFile && (
													<svg
														class="attachement_checkmark"
														xmlns="http://www.w3.org/2000/svg"
														width="16"
														height="16"
														viewBox="0 0 30 30"
													>
														<path
															id="check_circle"
															d="M12.9,21.9,23.475,11.325l-2.1-2.1L12.9,17.7,8.625,13.425l-2.1,2.1ZM15,30a14.606,14.606,0,0,1-5.85-1.181A14.976,14.976,0,0,1,1.181,20.85,14.606,14.606,0,0,1,0,15,14.606,14.606,0,0,1,1.181,9.15,14.977,14.977,0,0,1,9.15,1.181,14.606,14.606,0,0,1,15,0a14.606,14.606,0,0,1,5.85,1.181A14.977,14.977,0,0,1,28.819,9.15,14.606,14.606,0,0,1,30,15a14.606,14.606,0,0,1-1.181,5.85,14.977,14.977,0,0,1-7.969,7.969A14.606,14.606,0,0,1,15,30Z"
															transform="translate(0 0)"
															fill="#00c878"
														/>
													</svg>
												)}
												<span class="BugBTN-TooltipText">Attach a file</span>
											</button>
										</div>
									)}
									{attachmentFile && (
										<div className="Attachements_row d-flex align-items-center">
											<div>
												<svg
													className="attachment_button_container-img"
													xmlns="http://www.w3.org/2000/svg"
													viewBox="0 0 512 512"
												>
													<path d="M149.106 512c-33.076 0-66.153-12.59-91.333-37.771-50.364-50.361-50.364-132.305-.002-182.665L319.842 29.498c39.331-39.331 103.328-39.331 142.66 0 39.331 39.332 39.331 103.327 0 142.657l-222.63 222.626c-28.297 28.301-74.347 28.303-102.65 0-28.3-28.301-28.3-74.349 0-102.649l170.301-170.298c4.686-4.686 12.284-4.686 16.97 0l5.661 5.661c4.686 4.686 4.686 12.284 0 16.971l-170.3 170.297c-15.821 15.821-15.821 41.563.001 57.385 15.821 15.82 41.564 15.82 57.385 0l222.63-222.626c26.851-26.851 26.851-70.541 0-97.394-26.855-26.851-70.544-26.849-97.395 0L80.404 314.196c-37.882 37.882-37.882 99.519 0 137.401 37.884 37.881 99.523 37.882 137.404.001l217.743-217.739c4.686-4.686 12.284-4.686 16.97 0l5.661 5.661c4.686 4.686 4.686 12.284 0 16.971L240.44 474.229C215.26 499.41 182.183 512 149.106 512z"></path>
												</svg>

												<span class="Attachement_type"> {`${attachmentFile.name}`}</span>
											</div>
											<div class="ms-auto">
												<span href="#" class="Att_Del_icon" style={{ cursor: 'pointer' }}>
													<svg
														onClick={handleRemoveAttachmentFile}
														xmlns="http://www.w3.org/2000/svg"
														width="24"
														height="24"
														viewBox="0 0 24 24"
													>
														<path
															fill="#000000"
															fill-rule="evenodd"
															d="M13,18 L13,10 L15,10 L15,18 L13,18 Z M17.00005,20 L17.00005,10 L19.00005,10 L19.00005,20 C19.00005,21.1045 18.10455,22 17.00005,22 L7.00005,22 C5.89555,22 5.00005,21.1045 5.00005,20 L5.00005,10 L7.00005,10 L7.00005,20 L17.00005,20 Z M9,18 L9,10 L11,10 L11,18 L9,18 Z M9,6 L15,6 L15,4 L9,4 L9,6 Z M17,6 L20,6 C20.5525,6 21,6.448 21,7 L21,8 L3,8 L3,7 C3,6.448 3.448,6 4,6 L7,6 L7,4 C7,2.8955 7.8955,2 9,2 L15,2 C16.1045,2 17,2.8955 17,4 L17,6 Z"
														></path>
													</svg>
												</span>
											</div>
										</div>
									)}
									{screenCapture && (
										<div className="Attachements_row d-flex align-items-center">
											<div>
												<svg
													xmlns="http://www.w3.org/2000/svg"
													width="16px"
													viewBox="0 0 448 512"
													className="attachment_button_container-img"
												>
													<path d="M400 354.2V157.8C427.5 150.6 448 125.8 448 96c0-35.38-28.62-64-64-64c-29.75 0-54.63 20.5-61.75 48H125.8C118.6 52.5 93.75 32 64 32C28.62 32 0 60.62 0 96c0 29.75 20.5 54.62 48 61.75v196.5C20.5 361.4 0 386.2 0 416c0 35.38 28.62 64 64 64c29.75 0 54.62-20.5 61.75-48h196.5c7.125 27.5 32 48 61.75 48c35.38 0 64-28.62 64-64C448 386.2 427.5 361.4 400 354.2zM322.2 400H125.8C120 377.6 102.4 360.1 80 354.2V157.8C102.4 152 119.9 134.4 125.8 112h196.5C328.1 134.4 345.6 151.9 368 157.8v196.5C345.6 360.1 328.1 377.6 322.2 400zM384 64c17.62 0 32 14.38 32 32s-14.38 32-32 32s-32-14.38-32-32S366.4 64 384 64zM32 96c0-17.62 14.38-32 32-32s32 14.38 32 32S81.62 128 64 128S32 113.6 32 96zM64 448c-17.62 0-32-14.38-32-32s14.38-32 32-32s32 14.38 32 32S81.62 448 64 448zM384 448c-17.62 0-32-14.38-32-32s14.38-32 32-32s32 14.38 32 32S401.6 448 384 448z"></path>
												</svg>
												<span class="Attachement_type">Screenshot</span>
											</div>
											<div class="ms-auto">
												<span href="#" class="Att_Del_icon" style={{ cursor: 'pointer' }}>
													<svg
														onClick={handleClearScreenshot}
														xmlns="http://www.w3.org/2000/svg"
														width="24"
														height="24"
														viewBox="0 0 24 24"
													>
														<path
															fill="#000000"
															fill-rule="evenodd"
															d="M13,18 L13,10 L15,10 L15,18 L13,18 Z M17.00005,20 L17.00005,10 L19.00005,10 L19.00005,20 C19.00005,21.1045 18.10455,22 17.00005,22 L7.00005,22 C5.89555,22 5.00005,21.1045 5.00005,20 L5.00005,10 L7.00005,10 L7.00005,20 L17.00005,20 Z M9,18 L9,10 L11,10 L11,18 L9,18 Z M9,6 L15,6 L15,4 L9,4 L9,6 Z M17,6 L20,6 C20.5525,6 21,6.448 21,7 L21,8 L3,8 L3,7 C3,6.448 3.448,6 4,6 L7,6 L7,4 C7,2.8955 7.8955,2 9,2 L15,2 C16.1045,2 17,2.8955 17,4 L17,6 Z"
														></path>
													</svg>
												</span>
											</div>
										</div>
									)}
									{mediaBlobUrl && (
										<div className="Attachements_row d-flex align-items-center">
											<div>
												<svg
													className="recording_button_container-img"
													xmlns="http://www.w3.org/2000/svg"
													viewBox="0 0 576 512"
												>
													<path d="M558.8 99.64c-10.59-5.484-23.37-4.76-33.15 2.099l-102.8 72.04c-7.25 5.062-9 15.05-3.938 22.28C423.1 203.3 433.9 205 441.2 200L544 128v255.9L441.2 312c-7.266-5.047-17.22-3.312-22.28 3.938c-5.062 7.234-3.312 17.22 3.938 22.28l102.8 71.98c5.5 3.844 11.94 5.786 18.38 5.786c5.047 0 10.12-1.203 14.78-3.625C569.4 406.8 576 395.1 576 383.1V128C576 116 569.4 105.2 558.8 99.64zM320 64H64C28.65 64 0 92.65 0 128v256c0 35.35 28.65 64 64 64h256c35.35 0 64-28.65 64-64V128C384 92.65 355.3 64 320 64zM352 384c0 17.64-14.36 32-32 32H64c-17.64 0-32-14.36-32-32V128c0-17.64 14.36-32 32-32h256c17.64 0 32 14.36 32 32V384z"></path>
												</svg>
												<a href={mediaBlobUrl} target="_blank" className="Attachement_type">
													video.mp4
												</a>
											</div>
											<div class="ms-auto">
												<span href="#" class="Att_Del_icon" style={{ cursor: 'pointer' }}>
													<svg
													onClick={handleReset}
														xmlns="http://www.w3.org/2000/svg"
														width="24"
														height="24"
														viewBox="0 0 24 24"
													>
														<path
															fill="#000000"
															fill-rule="evenodd"
															d="M13,18 L13,10 L15,10 L15,18 L13,18 Z M17.00005,20 L17.00005,10 L19.00005,10 L19.00005,20 C19.00005,21.1045 18.10455,22 17.00005,22 L7.00005,22 C5.89555,22 5.00005,21.1045 5.00005,20 L5.00005,10 L7.00005,10 L7.00005,20 L17.00005,20 Z M9,18 L9,10 L11,10 L11,18 L9,18 Z M9,6 L15,6 L15,4 L9,4 L9,6 Z M17,6 L20,6 C20.5525,6 21,6.448 21,7 L21,8 L3,8 L3,7 C3,6.448 3.448,6 4,6 L7,6 L7,4 C7,2.8955 7.8955,2 9,2 L15,2 C16.1045,2 17,2.8955 17,4 L17,6 Z"
														></path>
													</svg>
												</span>
											</div>
										</div>
									)}
									<div className="create_issue_button_container">
										<button
											disabled={submitLoader}
											className="create_issue_button_container-btn"
											type="submit"
										>
											{submitLoader ? (
												<>
													<svg
														xmlns="http://www.w3.org/2000/svg"
														width={14}
														height={14}
														preserveAspectRatio="xMidYMid"
														style={{
															margin: 'auto',
															background: 'transparent',
															display: 'block',
															shapeRendering: 'auto',
														}}
														viewBox="0 0 100 100"
													>
														<circle
															cx={50}
															cy={50}
															r={35}
															fill="none"
															stroke="#fff"
															strokeDasharray="164.93361431346415 56.97787143782138"
															strokeWidth={10}
														>
															<animateTransform
																attributeName="transform"
																dur="1s"
																keyTimes="0;1"
																repeatCount="indefinite"
																type="rotate"
																values="0 50 50;360 50 50"
															/>
														</circle>
													</svg>
												</>
											) : (
												'Submit'
											)}
										</button>
									</div>
								</form>

								{successJiraMessage && <p className="success_message_jira">Successfully send</p>}
							</div>
						</div>
					</>
				)}
				{popupType === 3 && (
					<>
						<div className="BugFormTitle">Feedback</div>
						<div class="Bug_Form">
							<p class="text-center">Give general feedback of this page</p>
							<div className="popup-content">
								<form onSubmit={createJiraIssue}>
									<div className="mb-2">
										<input
											className="form-control"
											placeholder="Your Email address"
											type="email"
											required
											readOnly={isLoggedIn}
											value={email}
											onChange={(e) => setEmail(e.target.value)}
										/>
									</div>
									<div className="mb-2">
										<input
											className="form-control"
											value={issueTitle}
											placeholder="Add a title"
											required
											onChange={(e) => setIssueTitle(e.target.value)}
										/>
									</div>
									<div className="mb-2">
										<textarea
											rows="3"
											className="form-control"
											placeholder="Describe the feedback in detail"
											value={issueDescription}
											required
											onChange={(e) => setIssueDescription(e.target.value)}
										/>
									</div>

									{(screenCapture && attachmentFile) || (mediaBlobUrl && attachmentFile) ? (
										<></>
									) : (
										<div className="BugAttachment_Btns btn-group w-100">
											<button
												className="btn btn-outline-secondary BugBTN-Tooltip"
												role="button"
												disabled={mediaBlobUrl || screenCapture || isCheck ? true : false}
												onClick={() => {
													onStartCapture();
													setIsPopupOpen(!isPopupOpen);
													setShowRecorder(false);
												}}
											>
												{screenCapture && (
													<svg
														class="attachement_checkmark"
														xmlns="http://www.w3.org/2000/svg"
														width="16"
														height="16"
														viewBox="0 0 30 30"
													>
														<path
															id="check_circle"
															d="M12.9,21.9,23.475,11.325l-2.1-2.1L12.9,17.7,8.625,13.425l-2.1,2.1ZM15,30a14.606,14.606,0,0,1-5.85-1.181A14.976,14.976,0,0,1,1.181,20.85,14.606,14.606,0,0,1,0,15,14.606,14.606,0,0,1,1.181,9.15,14.977,14.977,0,0,1,9.15,1.181,14.606,14.606,0,0,1,15,0a14.606,14.606,0,0,1,5.85,1.181A14.977,14.977,0,0,1,28.819,9.15,14.606,14.606,0,0,1,30,15a14.606,14.606,0,0,1-1.181,5.85,14.977,14.977,0,0,1-7.969,7.969A14.606,14.606,0,0,1,15,30Z"
															transform="translate(0 0)"
															fill="#00c878"
														/>
													</svg>
												)}
												<span class="BugBTN-TooltipText">Screenshot</span>
												<svg
													className="screenshot_button_container-img"
													xmlns="http://www.w3.org/2000/svg"
													viewBox="0 0 448 512"
												>
													<path d="M400 354.2V157.8C427.5 150.6 448 125.8 448 96c0-35.38-28.62-64-64-64c-29.75 0-54.63 20.5-61.75 48H125.8C118.6 52.5 93.75 32 64 32C28.62 32 0 60.62 0 96c0 29.75 20.5 54.62 48 61.75v196.5C20.5 361.4 0 386.2 0 416c0 35.38 28.62 64 64 64c29.75 0 54.62-20.5 61.75-48h196.5c7.125 27.5 32 48 61.75 48c35.38 0 64-28.62 64-64C448 386.2 427.5 361.4 400 354.2zM322.2 400H125.8C120 377.6 102.4 360.1 80 354.2V157.8C102.4 152 119.9 134.4 125.8 112h196.5C328.1 134.4 345.6 151.9 368 157.8v196.5C345.6 360.1 328.1 377.6 322.2 400zM384 64c17.62 0 32 14.38 32 32s-14.38 32-32 32s-32-14.38-32-32S366.4 64 384 64zM32 96c0-17.62 14.38-32 32-32s32 14.38 32 32S81.62 128 64 128S32 113.6 32 96zM64 448c-17.62 0-32-14.38-32-32s14.38-32 32-32s32 14.38 32 32S81.62 448 64 448zM384 448c-17.62 0-32-14.38-32-32s14.38-32 32-32s32 14.38 32 32S401.6 448 384 448z"></path>
												</svg>
											</button>
											<button
												className="btn btn-outline-secondary BugBTN-Tooltip no-cursor"
												disabled={screenCapture || mediaBlobUrl || isCheck ? true : false}
												onClick={() => {
													setShowRecorder(true);
													setIsPopupOpen(!isPopupOpen);
												}}
											>
												{mediaBlobUrl && (
													<svg
														class="attachement_checkmark"
														xmlns="http://www.w3.org/2000/svg"
														width="16"
														height="16"
														viewBox="0 0 30 30"
													>
														<path
															id="check_circle"
															d="M12.9,21.9,23.475,11.325l-2.1-2.1L12.9,17.7,8.625,13.425l-2.1,2.1ZM15,30a14.606,14.606,0,0,1-5.85-1.181A14.976,14.976,0,0,1,1.181,20.85,14.606,14.606,0,0,1,0,15,14.606,14.606,0,0,1,1.181,9.15,14.977,14.977,0,0,1,9.15,1.181,14.606,14.606,0,0,1,15,0a14.606,14.606,0,0,1,5.85,1.181A14.977,14.977,0,0,1,28.819,9.15,14.606,14.606,0,0,1,30,15a14.606,14.606,0,0,1-1.181,5.85,14.977,14.977,0,0,1-7.969,7.969A14.606,14.606,0,0,1,15,30Z"
															transform="translate(0 0)"
															fill="#00c878"
														/>
													</svg>
												)}
												<span class="BugBTN-TooltipText">Record Screen</span>
												<svg
													className="recording_button_container-img"
													xmlns="http://www.w3.org/2000/svg"
													viewBox="0 0 576 512"
												>
													<path d="M558.8 99.64c-10.59-5.484-23.37-4.76-33.15 2.099l-102.8 72.04c-7.25 5.062-9 15.05-3.938 22.28C423.1 203.3 433.9 205 441.2 200L544 128v255.9L441.2 312c-7.266-5.047-17.22-3.312-22.28 3.938c-5.062 7.234-3.312 17.22 3.938 22.28l102.8 71.98c5.5 3.844 11.94 5.786 18.38 5.786c5.047 0 10.12-1.203 14.78-3.625C569.4 406.8 576 395.1 576 383.1V128C576 116 569.4 105.2 558.8 99.64zM320 64H64C28.65 64 0 92.65 0 128v256c0 35.35 28.65 64 64 64h256c35.35 0 64-28.65 64-64V128C384 92.65 355.3 64 320 64zM352 384c0 17.64-14.36 32-32 32H64c-17.64 0-32-14.36-32-32V128c0-17.64 14.36-32 32-32h256c17.64 0 32 14.36 32 32V384z"></path>
												</svg>
											</button>
											<button
												className="btn btn-outline-secondary BugBTN-Tooltip attachment_button_container"
												disabled={attachmentFile ? true : false}
												type="button"
											>
												<input
													id="file-input"
													name="file-input"
													type="file"
													accept="image/*"
													ref={inputFileRef}
													onChange={handleAttachmentChange}
												/>
												<svg
													className="attachment_button_container-img"
													xmlns="http://www.w3.org/2000/svg"
													viewBox="0 0 512 512"
												>
													<path d="M149.106 512c-33.076 0-66.153-12.59-91.333-37.771-50.364-50.361-50.364-132.305-.002-182.665L319.842 29.498c39.331-39.331 103.328-39.331 142.66 0 39.331 39.332 39.331 103.327 0 142.657l-222.63 222.626c-28.297 28.301-74.347 28.303-102.65 0-28.3-28.301-28.3-74.349 0-102.649l170.301-170.298c4.686-4.686 12.284-4.686 16.97 0l5.661 5.661c4.686 4.686 4.686 12.284 0 16.971l-170.3 170.297c-15.821 15.821-15.821 41.563.001 57.385 15.821 15.82 41.564 15.82 57.385 0l222.63-222.626c26.851-26.851 26.851-70.541 0-97.394-26.855-26.851-70.544-26.849-97.395 0L80.404 314.196c-37.882 37.882-37.882 99.519 0 137.401 37.884 37.881 99.523 37.882 137.404.001l217.743-217.739c4.686-4.686 12.284-4.686 16.97 0l5.661 5.661c4.686 4.686 4.686 12.284 0 16.971L240.44 474.229C215.26 499.41 182.183 512 149.106 512z"></path>
												</svg>
												<label for="file-input" style={{ opacity: '0' }}></label>
												{attachmentFile && (
													<svg
														class="attachement_checkmark"
														xmlns="http://www.w3.org/2000/svg"
														width="16"
														height="16"
														viewBox="0 0 30 30"
													>
														<path
															id="check_circle"
															d="M12.9,21.9,23.475,11.325l-2.1-2.1L12.9,17.7,8.625,13.425l-2.1,2.1ZM15,30a14.606,14.606,0,0,1-5.85-1.181A14.976,14.976,0,0,1,1.181,20.85,14.606,14.606,0,0,1,0,15,14.606,14.606,0,0,1,1.181,9.15,14.977,14.977,0,0,1,9.15,1.181,14.606,14.606,0,0,1,15,0a14.606,14.606,0,0,1,5.85,1.181A14.977,14.977,0,0,1,28.819,9.15,14.606,14.606,0,0,1,30,15a14.606,14.606,0,0,1-1.181,5.85,14.977,14.977,0,0,1-7.969,7.969A14.606,14.606,0,0,1,15,30Z"
															transform="translate(0 0)"
															fill="#00c878"
														/>
													</svg>
												)}
												<span class="BugBTN-TooltipText">Attach a file</span>
											</button>
										</div>
									)}
									{attachmentFile && (
										<div className="Attachements_row d-flex align-items-center">
											<div>
												<svg
													className="attachment_button_container-img"
													xmlns="http://www.w3.org/2000/svg"
													viewBox="0 0 512 512"
												>
													<path d="M149.106 512c-33.076 0-66.153-12.59-91.333-37.771-50.364-50.361-50.364-132.305-.002-182.665L319.842 29.498c39.331-39.331 103.328-39.331 142.66 0 39.331 39.332 39.331 103.327 0 142.657l-222.63 222.626c-28.297 28.301-74.347 28.303-102.65 0-28.3-28.301-28.3-74.349 0-102.649l170.301-170.298c4.686-4.686 12.284-4.686 16.97 0l5.661 5.661c4.686 4.686 4.686 12.284 0 16.971l-170.3 170.297c-15.821 15.821-15.821 41.563.001 57.385 15.821 15.82 41.564 15.82 57.385 0l222.63-222.626c26.851-26.851 26.851-70.541 0-97.394-26.855-26.851-70.544-26.849-97.395 0L80.404 314.196c-37.882 37.882-37.882 99.519 0 137.401 37.884 37.881 99.523 37.882 137.404.001l217.743-217.739c4.686-4.686 12.284-4.686 16.97 0l5.661 5.661c4.686 4.686 4.686 12.284 0 16.971L240.44 474.229C215.26 499.41 182.183 512 149.106 512z"></path>
												</svg>

												<span class="Attachement_type"> {`${attachmentFile.name}`}</span>
											</div>
											<div class="ms-auto">
												<span href="#" class="Att_Del_icon" style={{ cursor: 'pointer' }}>
													<svg
														onClick={handleRemoveAttachmentFile}
														xmlns="http://www.w3.org/2000/svg"
														width="24"
														height="24"
														viewBox="0 0 24 24"
													>
														<path
															fill="#000000"
															fill-rule="evenodd"
															d="M13,18 L13,10 L15,10 L15,18 L13,18 Z M17.00005,20 L17.00005,10 L19.00005,10 L19.00005,20 C19.00005,21.1045 18.10455,22 17.00005,22 L7.00005,22 C5.89555,22 5.00005,21.1045 5.00005,20 L5.00005,10 L7.00005,10 L7.00005,20 L17.00005,20 Z M9,18 L9,10 L11,10 L11,18 L9,18 Z M9,6 L15,6 L15,4 L9,4 L9,6 Z M17,6 L20,6 C20.5525,6 21,6.448 21,7 L21,8 L3,8 L3,7 C3,6.448 3.448,6 4,6 L7,6 L7,4 C7,2.8955 7.8955,2 9,2 L15,2 C16.1045,2 17,2.8955 17,4 L17,6 Z"
														></path>
													</svg>
												</span>
											</div>
										</div>
									)}
									{screenCapture && (
										<div className="Attachements_row d-flex align-items-center">
											<div>
												<svg
													xmlns="http://www.w3.org/2000/svg"
													width="16px"
													viewBox="0 0 448 512"
													className="attachment_button_container-img"
												>
													<path d="M400 354.2V157.8C427.5 150.6 448 125.8 448 96c0-35.38-28.62-64-64-64c-29.75 0-54.63 20.5-61.75 48H125.8C118.6 52.5 93.75 32 64 32C28.62 32 0 60.62 0 96c0 29.75 20.5 54.62 48 61.75v196.5C20.5 361.4 0 386.2 0 416c0 35.38 28.62 64 64 64c29.75 0 54.62-20.5 61.75-48h196.5c7.125 27.5 32 48 61.75 48c35.38 0 64-28.62 64-64C448 386.2 427.5 361.4 400 354.2zM322.2 400H125.8C120 377.6 102.4 360.1 80 354.2V157.8C102.4 152 119.9 134.4 125.8 112h196.5C328.1 134.4 345.6 151.9 368 157.8v196.5C345.6 360.1 328.1 377.6 322.2 400zM384 64c17.62 0 32 14.38 32 32s-14.38 32-32 32s-32-14.38-32-32S366.4 64 384 64zM32 96c0-17.62 14.38-32 32-32s32 14.38 32 32S81.62 128 64 128S32 113.6 32 96zM64 448c-17.62 0-32-14.38-32-32s14.38-32 32-32s32 14.38 32 32S81.62 448 64 448zM384 448c-17.62 0-32-14.38-32-32s14.38-32 32-32s32 14.38 32 32S401.6 448 384 448z"></path>
												</svg>
												<span class="Attachement_type">Screenshot</span>
											</div>
											<div class="ms-auto">
												<span href="#" class="Att_Del_icon" style={{ cursor: 'pointer' }}>
													<svg
														onClick={handleClearScreenshot}
														xmlns="http://www.w3.org/2000/svg"
														width="24"
														height="24"
														viewBox="0 0 24 24"
													>
														<path
															fill="#000000"
															fill-rule="evenodd"
															d="M13,18 L13,10 L15,10 L15,18 L13,18 Z M17.00005,20 L17.00005,10 L19.00005,10 L19.00005,20 C19.00005,21.1045 18.10455,22 17.00005,22 L7.00005,22 C5.89555,22 5.00005,21.1045 5.00005,20 L5.00005,10 L7.00005,10 L7.00005,20 L17.00005,20 Z M9,18 L9,10 L11,10 L11,18 L9,18 Z M9,6 L15,6 L15,4 L9,4 L9,6 Z M17,6 L20,6 C20.5525,6 21,6.448 21,7 L21,8 L3,8 L3,7 C3,6.448 3.448,6 4,6 L7,6 L7,4 C7,2.8955 7.8955,2 9,2 L15,2 C16.1045,2 17,2.8955 17,4 L17,6 Z"
														></path>
													</svg>
												</span>
											</div>
										</div>
									)}
									{mediaBlobUrl && (
										<div className="Attachements_row d-flex align-items-center">
											<div>
												<svg
													className="recording_button_container-img"
													xmlns="http://www.w3.org/2000/svg"
													viewBox="0 0 576 512"
												>
													<path d="M558.8 99.64c-10.59-5.484-23.37-4.76-33.15 2.099l-102.8 72.04c-7.25 5.062-9 15.05-3.938 22.28C423.1 203.3 433.9 205 441.2 200L544 128v255.9L441.2 312c-7.266-5.047-17.22-3.312-22.28 3.938c-5.062 7.234-3.312 17.22 3.938 22.28l102.8 71.98c5.5 3.844 11.94 5.786 18.38 5.786c5.047 0 10.12-1.203 14.78-3.625C569.4 406.8 576 395.1 576 383.1V128C576 116 569.4 105.2 558.8 99.64zM320 64H64C28.65 64 0 92.65 0 128v256c0 35.35 28.65 64 64 64h256c35.35 0 64-28.65 64-64V128C384 92.65 355.3 64 320 64zM352 384c0 17.64-14.36 32-32 32H64c-17.64 0-32-14.36-32-32V128c0-17.64 14.36-32 32-32h256c17.64 0 32 14.36 32 32V384z"></path>
												</svg>
												<a href={mediaBlobUrl} target="_blank" className="Attachement_type">
													video.mp4
												</a>
											</div>
											<div class="ms-auto">
												<span href="#" class="Att_Del_icon" style={{ cursor: 'pointer' }}>
													<svg
													onClick={handleReset}
														xmlns="http://www.w3.org/2000/svg"
														width="24"
														height="24"
														viewBox="0 0 24 24"
													>
														<path
															fill="#000000"
															fill-rule="evenodd"
															d="M13,18 L13,10 L15,10 L15,18 L13,18 Z M17.00005,20 L17.00005,10 L19.00005,10 L19.00005,20 C19.00005,21.1045 18.10455,22 17.00005,22 L7.00005,22 C5.89555,22 5.00005,21.1045 5.00005,20 L5.00005,10 L7.00005,10 L7.00005,20 L17.00005,20 Z M9,18 L9,10 L11,10 L11,18 L9,18 Z M9,6 L15,6 L15,4 L9,4 L9,6 Z M17,6 L20,6 C20.5525,6 21,6.448 21,7 L21,8 L3,8 L3,7 C3,6.448 3.448,6 4,6 L7,6 L7,4 C7,2.8955 7.8955,2 9,2 L15,2 C16.1045,2 17,2.8955 17,4 L17,6 Z"
														></path>
													</svg>
												</span>
											</div>
										</div>
									)}
									<div className="create_issue_button_container">
										<button
											disabled={submitLoader}
											className="create_issue_button_container-btn"
											type="submit"
										>
											{submitLoader ? (
												<>
													<svg
														xmlns="http://www.w3.org/2000/svg"
														width={14}
														height={14}
														preserveAspectRatio="xMidYMid"
														style={{
															margin: 'auto',
															background: 'transparent',
															display: 'block',
															shapeRendering: 'auto',
														}}
														viewBox="0 0 100 100"
													>
														<circle
															cx={50}
															cy={50}
															r={35}
															fill="none"
															stroke="#fff"
															strokeDasharray="164.93361431346415 56.97787143782138"
															strokeWidth={10}
														>
															<animateTransform
																attributeName="transform"
																dur="1s"
																keyTimes="0;1"
																repeatCount="indefinite"
																type="rotate"
																values="0 50 50;360 50 50"
															/>
														</circle>
													</svg>
												</>
											) : (
												'Submit'
											)}
										</button>
									</div>
								</form>

								{successJiraMessage && <p className="success_message_jira">Successfully send</p>}
							</div>
						</div>
					</>
				)}
				{popupType === 4 && (
					<>
						<div style={{ textAlign: 'center', padding: '50px 0' }}>
							<div style={{ marginBottom: '30px' }}>
								<svg
									class="attachement_checkmark"
									xmlns="http://www.w3.org/2000/svg"
									width="48"
									height="48"
									viewBox="0 0 30 30"
								>
									<path
										id="check_circle"
										d="M12.9,21.9,23.475,11.325l-2.1-2.1L12.9,17.7,8.625,13.425l-2.1,2.1ZM15,30a14.606,14.606,0,0,1-5.85-1.181A14.976,14.976,0,0,1,1.181,20.85,14.606,14.606,0,0,1,0,15,14.606,14.606,0,0,1,1.181,9.15,14.977,14.977,0,0,1,9.15,1.181,14.606,14.606,0,0,1,15,0a14.606,14.606,0,0,1,5.85,1.181A14.977,14.977,0,0,1,28.819,9.15,14.606,14.606,0,0,1,30,15a14.606,14.606,0,0,1-1.181,5.85,14.977,14.977,0,0,1-7.969,7.969A14.606,14.606,0,0,1,15,30Z"
										transform="translate(0 0)"
										fill="#00c878"
									/>
								</svg>
							</div>
							<h2 style={{ marginBottom: '30px' }}>Thank you!</h2>
							<p style={{ marginBottom: '30px' }}>We really appreciate your feedback.</p>
						</div>
					</>
				)}

				{/* <svg
					onClick={onClosePopup}
					className="popup-close-icon"
					version="1.1"
					id="Layer_1"
					xmlns="http://www.w3.org/2000/svg"
					x="0px"
					y="0px"
					width="25.881px"
					height="25.88px"
					viewBox="0 0 122.881 122.88"
					enableBackground="new 0 0 122.881 122.88"
				>
					<g>
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							d="M61.44,0c33.933,0,61.441,27.507,61.441,61.439 c0,33.933-27.508,61.44-61.441,61.44C27.508,122.88,0,95.372,0,61.439C0,27.507,27.508,0,61.44,0L61.44,0z M81.719,36.226 c1.363-1.363,3.572-1.363,4.936,0c1.363,1.363,1.363,3.573,0,4.936L66.375,61.439l20.279,20.278c1.363,1.363,1.363,3.573,0,4.937 c-1.363,1.362-3.572,1.362-4.936,0L61.44,66.376L41.162,86.654c-1.362,1.362-3.573,1.362-4.936,0c-1.363-1.363-1.363-3.573,0-4.937 l20.278-20.278L36.226,41.162c-1.363-1.363-1.363-3.573,0-4.936c1.363-1.363,3.573-1.363,4.936,0L61.44,56.504L81.719,36.226 L81.719,36.226z"
						/>
					</g>
				</svg> */}
			</div>
		</div>
	);
};

export default FeedbackReportModal;
